module.exports = __webpack_public_path__ + "img/8B795F_291504_EFE5D4_4A3518-256px.44b91454.png";